<template>
    <div
        :class="[
            'banner-generic--container',
            data.content ? null : 'space-bottom--md'
        ]"
    >
        <div
            :class="[
                'banner banner--theme banner--generic',
                { 'no-image': imageType === 'undefined' },
                { 'content-inside': isContentInside }
            ]"
        >
            <img
                v-if="imageType !== 'undefined'"
                :src="`${imageType === 'string' ? data.image : data.image[0]}`"
                :srcset="srcSet"
                :alt="data.title"
                fetchpriority="high"
                sizes="(max-width: 300px) 300px,(max-width: 900px) 900px,1800px"
                class="banner--generic--image"
            />

            <div class="banner-primary">
                <div class="container">
                    <div class="col-content">
                        <div class="banner-content">
                            <p v-if="isContentInside && preText" class="pretext hidden--desktop">
                                {{preText}}
                            </p>

                            <h1 :class="{'no--margin': isContentInside}">
                                {{data.title}}
                            </h1>

                            <div
                                v-if="isContentInside && data.content"
                                v-html="data.content"
                                class="wysiwyg-content hidden--desktop"
                            >
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="banner--generic--overlay"></div>
        </div>
         <div v-if="data.content" :class="['space--md', {'hidden--mobile': isContentInside}]">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-xl-12 wysiwyg-content" v-html="data.content"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "banner-generic",
        props: {
            data: {
                type: Object
            },
            isContentInside: {
                type: Boolean,
                default: false
            },
            preText: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                imageType: 'string',
                srcSet: undefined,
            };
        },
        computed: {

        },
        methods: {

        },
        mounted() {
            var image = this.data.image;

            if (typeof image === 'string' && image !== '') {
                this.imageType = 'string';
                this.srcSet = undefined;
            } else if (typeof image === 'object' && image.length) {
                this.imageType = 'array';
                this.srcSet = `${image[0] ? image[0] + ' 300w,' : ''}${image[1] ? image[1] + ' 900w,' : ''}${image[2] ? image[2] + ' 1800w' : ''}`;
            } else {
                this.imageType = 'undefined';
            }
        }
    };
</script>


<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";

    .wysiwyg-content {
        > :first-child {
            margin-top: 0;
        }
        > :last-child {
            margin-bottom: 0;
        }
    }

    .banner--generic {
        position: relative;
        overflow: hidden;
        //max-height: auto;
        max-height: 380px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        background-color: transparent;

        @media #{$lg} {
            max-height: 380px;
        }

        @media (max-width:767px) {
            background-color: $brand-blue;
        }
        
        &.no-image {
            background-color: $brand-blue;
        }

        img {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            object-fit: cover;
            z-index: 0;

            @media (max-width:767px) {
                display: none;
            }
        }

        .container {
            display: block;

            @media #{$lg} {
                display: flex;
            }

            .col-content {
                width: 100%;
                display: block;


                @media #{$lg} {
                    width: 60%;
                    display: flex;
                    align-items: center;
                }

                .banner-content {
                    max-width: 100%;
                    margin-top: 0;

                    @media #{$lg} {
                        max-width: 750px;
                        margin-top: 60px;
                    }
                }
            }
        }

        .banner-primary {
            .container {
                .col-content {
                    height: auto;
                    padding: 120px 0 60px 0;

                    @media #{$lg} {
                        height: 380px;
                        padding: 0;
                    }
                }
            }
        }
    }

    .banner-primary {
        position: relative;
        z-index: 2;

        h1 {
            color: #000000;
        }
    }

    .banner--generic--overlay {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0.3;
        background-color: #ffffff;
    }

    // added new style for visualizer page
    .content-inside {
        @media #{$below-md} {
            max-height: none;
        }

        .banner-primary .container .col-content {
            @media #{$below-md} {
                padding: 154px 0 28px 0;
            }
        }

        .pretext {
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 8px;
        }

        .wysiwyg-content {
            margin-top: 20px;

            > :first-child {
                margin-top: 0;
            }

            > :last-child {
                margin-bottom: 0;
            }
        }
    }

    //@media #{$sm} {}
    //@media #{$md} {}
    //@media #{$lg} {}
    //@media #{$xl} {}

</style>
